import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useGetAboutMeQuery } from '../app/globalApi';
import { setPermissions, setUserRole } from '../app/globalSlice';
import { checkPermission as baseCheckPermission } from '../helpers/AccessControlUtils';

const usePermissions = () => {
  const dispatch = useDispatch();

  const reduxPermissions = useSelector(state => state.global.permissions);
  const userRole = useSelector(state => state.global.userRole);

  const hasAuthToken = !!localStorage.getItem('authToken');
  const shouldFetch = hasAuthToken && reduxPermissions.length === 0;

  const { data: aboutMeData, isLoading, isError } = useGetAboutMeQuery(undefined, {
    skip: !shouldFetch,
  });

  useEffect(() => {
    if (aboutMeData?.data) {
      const permissions = aboutMeData.data.permissions || [];
      const role = aboutMeData.data.role_name || null;
      dispatch(setPermissions(permissions));
      dispatch(setUserRole(role));
    }
  }, [aboutMeData, dispatch]);


  const checkPermission = (permissionName, action) => {
    return baseCheckPermission(permissionName, action, reduxPermissions);
  };

  return {
    permissions: reduxPermissions,
    userRole,
    isLoading,
    isError,
    checkPermission,
  };
};

export default usePermissions;
